export const driverStatusTranslate = {
  disable: 'Bloqueados',
  approved: 'Aprovados',
  pending: 'Pendentes',
  'pre-approved': 'Pré-aprovados',
  'pending-documents': 'Incompletos',
  'pending-gr': 'Pendentes de GR',
  'analyze-gr': 'Análise de GR',
  obsolet: 'Obsoletos',
  rejected: 'Bloqueados'
}

export const offerStatusTranslate = {
  pending: `Disponíveis`,
  waiting: `Contratadas`,
  sending: `Em Trânsito`,
  delivered: `Entregues`,
  finished: `Finalizadas`,
  in_negotiation: `Em Negociação`,
}

export const driverAuditActionTranslate = {
  store: 'Cadastro',
  update: 'Edição',
  update_status: 'Alteração de Status',
  'update-status': 'Alteração de Status',
  'update-is-active': '',
  current_vehicle: 'Veículo Atual',
  attach_vehicle: 'Vinculação de Veículo',
  detach_vehicle: 'Desvinculação de Veículo',
  attach_preference: 'Vinculação de Preferência',
  remove_preference: 'Desvinculação de Preferência',
  approvedGR: 'Aprovado GR',
  rejectedGR: 'Reprovado GR',
  favorite: 'Fidelização',
  trackDriver: 'Rastreamento',
  upload_antt: 'Envio ANTT',
  update_antt: 'Atualização ANTT',
  save_proof_residence: 'Envio Comprovante de Residência',
  save_cnh: 'Envio CNH',
}
